import { startTransition, useEffect, useState } from "react";
//#region src/index.tsx
var useIsSsr = () => {
	const [isServer, setIsServer] = useState(true);
	useEffect(() => {
		startTransition(() => {
			setIsServer(false);
		});
	}, []);
	return isServer;
};
//#endregion
export { useIsSsr };
